import {AjaxDataTypes} from '../../../../shared/AjaxDataTypes'
import {TranslationObject} from '@colonist/i18n'
import {StoreProductType} from '../../../../shared/store/BaseColonistStoreProduct'
import {UIAjaxWrapper} from '../network/UIAjaxWrapper'
import {UIAPIEndpoints} from '../network/UIAPIEndpoints'
import {UIPopupController} from '../ui_popup/UIPopupController'
import {ColonistOneTimePurchaseType} from '@colonist/types'
import {GiftPurchaseData} from '../../../../shared/store/GiftPurchaseData'
import {navigateToPage} from '../ui_utils/ClientUtils.ts'

declare let stripe: any

export class UICheckoutAjaxEndPoints {
    static async executeStripeColonistProductPurchaseSession(storeProductType: StoreProductType, type: number, itemQuantity: number = 1) {
        const url = `${UIAPIEndpoints.apiPayGetStoreStripeSession()}/${storeProductType}/${type}/${itemQuantity}`
        const response = await UIAjaxWrapper.postRequestHandler(url, undefined, undefined)
        if(response == undefined) return

        void this.gotCheckoutSession(response.json as AjaxDataTypes.StripeCheckoutRequestStatus)
    }

    static async executeStripeColonistGiftPurchaseSession(purchaseType: ColonistOneTimePurchaseType, giftPurchaseData: GiftPurchaseData) {
        const storeProductType = StoreProductType.OneTimePurchase
        const url = `${UIAPIEndpoints.apiPayGetStoreStripeSession()}/${storeProductType}/${purchaseType}/${giftPurchaseData.duration}`
        const response = await UIAjaxWrapper.postRequestHandler(url, undefined, giftPurchaseData)
        if(response == undefined) return

        void this.gotCheckoutSession(response.json as AjaxDataTypes.StripeCheckoutRequestStatus)
    }

    static async gotCheckoutSession(response: AjaxDataTypes.StripeCheckoutRequestStatus) {
        if(!response.status) {
            UIPopupController.createSimplePopup({key: 'strings:storePage.errors.fail'}, response.message)
            return
        }

        const stripeRedirectResult = await stripe.redirectToCheckout({sessionId: response.session.id})
        const englishMessage: TranslationObject = {key: 'strings:colonistCommon.utils.#buffer', options: {value: stripeRedirectResult.error.message}}
        UIPopupController.createSimplePopup({key: 'strings:storePage.errors.fail'}, englishMessage)
    }

    static async executeXsollaColonistCoinPurchaseSession(storeProductType: StoreProductType, type: number) {
        const url = `${UIAPIEndpoints.apiPayGetStoreXsollaSession()}/${storeProductType}/${type}`
        const response = await UIAjaxWrapper.postRequestHandler(url, undefined, undefined)
        if(response == undefined) return
        navigateToPage(response.json)
    }

    static async executeStripeCustomerPortalSession() {
        const response = await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiPayCreateCustomerPortalSession(), undefined, undefined)
        if(response == undefined) return
        navigateToPage(response.json)
    }
}
